export default "__VITE_ASSET__CAUr4bGI__"